import React, { forwardRef }  from "react";
import { useQueryClient } from '@tanstack/react-query';
import {ThemeProvider, createTheme} from "@mui/material/styles";
import {useGetOperationalTeams, }  from '../../queries/AttorneyInfo';
import MaterialTable from "material-table";
import axios from "axios";
import "./style.scss";

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

const tableIcons: any = {
    Add: forwardRef((props, ref) => <AddBox {...props} />),
    Check: forwardRef((props, ref) => <Check {...props}  />),
    Clear: forwardRef((props, ref) => <Clear {...props}  />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props}  />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props}  />),
    Edit: forwardRef((props, ref) => <Edit {...props}  />),
    Export: forwardRef((props, ref) => <SaveAlt {...props}  />),
    Filter: forwardRef((props, ref) => <FilterList {...props}  />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props}  />),
    LastPage: forwardRef((props, ref) => <LastPage {...props}  />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props}  />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props}  />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props}  />),
    Search: forwardRef((props, ref) => <Search {...props}  />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props}  />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props}  />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props}  />)
};


const EditTable: React.FC = () => {
    const { useState } = React;
    const defaultMaterialTheme = createTheme();
    const queryClient = useQueryClient();

    const [columns, setColumns] = useState<any>([
      { title: 'Attorney Team', field: 'team_name' },
      { title: 'Lawyer Overhead Component', field: 'operational_costs',  type: 'numeric' },
    ]);

    const { 
      data: operationalTeamData, 
      isLoading, 
      isError,
      refetch
    } = useGetOperationalTeams();

    if(isLoading) return <></>;

    return (
    <ThemeProvider theme={defaultMaterialTheme}>
      <MaterialTable
        title="Edit Attorney Team Attributes"
        columns={columns}
        data={operationalTeamData || []}
        icons={tableIcons}
        options={{
            pageSize: 10,
            search: false,
            headerStyle: {
                backgroundColor: "#3f51b5",
                color: "#FFF",
                fontWeight: "bold",
            },
        }}
        
        editable={{
          onRowAdd: (newData: any) => new Promise( async (resolve, reject) => {
            const response = await axios.put(
              `https://api.concept.lawscore.com/api/operational_teams`,
                { "entries": [newData] }
            );
            const data: any = response.data;
            queryClient.invalidateQueries({ queryKey: ["Operational-Teams"] });
            resolve(data);
          }),
          onRowUpdate: (newData, oldData: any) =>
            new Promise( async (resolve, reject) => {
              const index = oldData.tableData.id;
              const dataUpdate = [(operationalTeamData || [])[index]]
              const oldIndex = dataUpdate[0].team_name;
              dataUpdate[0] = newData;
              dataUpdate[0].index = oldIndex;

              const response = await axios.post(
                `https://api.concept.lawscore.com/api/operational_teams`,
                  { "entries": dataUpdate }
              );
              const data: any = response.data;
              queryClient.invalidateQueries({ queryKey: ["Operational-Teams"] });
              resolve(data);
            }),
          onRowDelete: (oldData: any) =>
            new Promise( async (resolve, reject) => {
              const index = oldData.tableData.id;
              const dataUpdate = [(operationalTeamData || [])[index]];
              //setData([...dataDelete]);
              const response = await axios.delete(
                `https://api.concept.lawscore.com/api/operational_teams`,
                  { headers: {}, data: { "entries": dataUpdate } }
              );
              const data: any = response.data;
              queryClient.invalidateQueries({ queryKey: ["Operational-Teams"] });
              resolve(data);
            }),
        }}
      />
    </ThemeProvider>
    )

}

const TeamSettings: React.FC = () => {
	
	return (
		<div className="home-wrapper table-layout">
			<h2>Settings</h2>
			<div className="mailchimp-table-wrapper">
                <EditTable />
			</div>
		</div>
	);
};

export default TeamSettings;
